// extracted by mini-css-extract-plugin
export var chevron = "_1z-d";
export var disabled = "_1z-b";
export var error = "_1z-c";
export var hideBorder = "_1z-1";
export var icon = "_1z-e";
export var input = "_1z-0";
export var large = "_1z-f";
export var open = "_1z-9";
export var placeholder = "_1z-a";
export var regular = "_1z-5";
export var singleRowInput = "_1z-2";
export var singleSelectInput = "_1z-3 _1z-0";
export var small = "_1z-4";
export var spinnerContainer = "_1z-i";
export var tag = "_1z-7";
export var tagsContainer = "_1z-8";
export var tagsInput = "_1z-6 _1z-0";
export var xSmall = "_1z-g";
export var xxSmall = "_1z-h";